global.jQuery = global.$ = require("jquery");

let flagSubNav2 = false;
let flagSubNav3 = false;

const nav = $('[data-nav');
const hambuger = document.querySelector('[data-hambuger]');
const headerSC = document.querySelector('header');

const header = {
    init() {
        header.controlNav();
        header.stickyNav();

        // Get total_cart
        $.ajax({
            url: window?.talentnet?.ajax_url,
            type: 'POST',
            data: {
                action: 'get_cart_count'
            },
            success: function(response) {
                $('header .cta-cart').find('.number').remove();
                $('header .cta-cart').append(`<span class="number">${response}</span>`);
            }
        });
    },
    openNav() {
        document.documentElement.classList.add('on-nav');
        document.body.classList.add('on-nav');
        $('body').removeClass('no-scroll');
        nav.addClass('on');
        hambuger.classList.add('on');
        headerSC.classList.add('open-nav');

        setTimeout(function() {
            hambuger.setAttribute('aria-expanded', 'true');
        }, 299);
    },
    closeNav() {
        var _time = 0;
        hambuger.classList.remove('on');
        headerSC.classList.remove('open-nav');

        if (flagSubNav3) {
            flagSubNav3 = false;

            nav.find('.ul-sub > li').removeClass('on');
            nav.find('.ul-sub > li > [data-expand]').removeClass('on').attr('aria-expanded', 'false');
            $('[data-sub-nav-content][data-level-03]').removeClass('on');
            $('[data-sub-nav-group][data-level-03]').removeClass('on');

            _time += 400;
        }

        if (flagSubNav2) {
            flagSubNav2 = false;
            setTimeout(function() {
                nav.find('.ul-main > li').removeClass('on');
                nav.find('.ul-main > li [data-expand]').removeClass('on').attr('aria-expanded', 'false');
                $('[data-sub-nav-content][data-level-02]').removeClass('on');
                $('[data-sub-nav-group][data-level-02]').removeClass('on');
            }, _time);
            _time += 400;
        }

        setTimeout(function() {
            nav.removeClass('on')
            nav.removeClass('on-sub');
            setTimeout(function() {
                document.documentElement.classList.remove('on-nav');
                document.body.classList.remove('on-nav');
                hambuger.setAttribute('aria-expanded', 'false');
            }, 400);

        }, _time);
    },
    openSubNav(subName) {
        const node = $(`[data-expand][data-name="${subName}"]`);
        const subNav = $('[data-sub-nav-content][data-name="' + subName + '"]');
        nav.addClass('on-sub');
        subNav.addClass('on').siblings().removeClass('on');

        if (subNav.is('[data-level-03]')) {
            flagSubNav3 = true;

            nav.find('.ul-sub > li').not(node.parent()).removeClass('on');
            node.parent().addClass('on');
            nav.find('.ul-sub > li > [data-expand]').not(node).attr('aria-expanded', 'false').removeClass('on');
            $('[data-sub-nav-group][data-level-03]').addClass('on');
        }

        if (subNav.is('[data-level-02]')) {
            flagSubNav2 = true;

            if (flagSubNav3) {
                flagSubNav3 = false;

                nav.find('.ul-sub > li').not(node.parent()).removeClass('on');
                node.parent().addClass('on');
                nav.find('.ul-sub > li > [data-expand]').not(node).attr('aria-expanded', 'false').removeClass('on');
                $('[data-sub-nav-group][data-level-03]').removeClass('on');
            }

            nav.find('.ul-main > li').not(node.parent()).removeClass('on');
            node.parent().addClass('on');
            nav.find('.ul-main > li > [data-expand]').not(node).attr('aria-expanded', 'false').removeClass('on');
            $('[data-sub-nav-group][data-level-02]').addClass('on');
        }

        node.attr('aria-expanded', 'true').addClass('on');

    },
    closeSubNav(level) {
        if (level == 3) {
            flagSubNav3 = false;

            nav.find('.ul-sub > li').removeClass('on');
            nav.find('.ul-sub > li > [data-expand]').removeClass('on').attr('aria-expanded', 'false');
            $('[data-sub-nav-content][data-level-03]').removeClass('on');
            $('[data-sub-nav-group][data-level-03]').removeClass('on');
        }

        if (level == 2) {
            if (flagSubNav3) {
                flagSubNav3 = false;

                nav.find('.ul-sub > li').removeClass('on');
                nav.find('.ul-sub > li > [data-expand]').removeClass('on').attr('aria-expanded', 'false');
                $('[data-sub-nav-content][data-level-03]').removeClass('on');
                $('[data-sub-nav-group][data-level-03]').removeClass('on');
            }

            flagSubNav2 = false;

            nav.find('.ul-main > li').removeClass('on');
            nav.find('.ul-main > li [data-expand]').removeClass('on').attr('aria-expanded', 'false');
            $('[data-sub-nav-content][data-level-02]').removeClass('on');
            $('[data-sub-nav-group][data-level-02]').removeClass('on');
            nav.removeClass('on-sub');
        }
    },
    controlNav() {

        // nav mobile
        nav.children('[data-nav-close]').on('click', function(event) {
            event.preventDefault();
            header.closeNav();
        });

        nav.find('[data-expand]').on('click', function(event) {
            event.preventDefault();
            var _this = $(this),
                _name = _this.data("name");

            header.openSubNav(_name);
        });

        nav.find('[data-back-element]').on('click', function(event) {
            event.preventDefault();

            var _name = $(this).data('name');

            const node = $(`[data-expand][data-name="${_name}"]`);

            node.attr('aria-expanded', 'false');
            node.parent().removeClass('on');

            if ($(this).parents('[data-level-03]').length > 0) {
                $('[data-sub-nav-group][data-level-03]').removeClass('on');
                flagSubNav3 = false;
                nav.find('.ul-sub > li').removeClass('is-current');
            }

            if ($(this).parents('[data-level-02]').length > 0) {
                $('[data-sub-nav-group][data-level-02]').removeClass('on');
                flagSubNav2 = false;
                nav.find('.ul-main > li').removeClass('is-current');
            }

            if ($(this).parents('[data-level-03]').length == 0) {
                if ($(this).parents('[data-level-02]').length) {
                    nav.removeClass('on-sub');
                }
            }

        });

        var timeoutId;
        var timeoutId2;
        var isLeaving = true;
        var submenuHover = false;
        var subchildMenuHover = false;

        nav.find('li').hover(function() {
            var $this = $(this),
                _name = $this.children('[data-expand]').first().data('name');

            if ($(window).width() > 767) {
                if ($this.hasClass('is-dropdown')) {
                    clearTimeout(timeoutId2);
                    isLeaving = false;
                    timeoutId = setTimeout(function() {
                        header.openSubNav(_name);
                    }, 200);
                } else {
                    clearTimeout(timeoutId);
                    timeoutId2 = setTimeout(function() {
                        if (isLeaving) {
                            if (!subchildMenuHover) {
                                if (submenuHover) {
                                    header.closeSubNav(3);
                                } else {
                                    header.closeSubNav(2);
                                }
                            }
                        }
                    }, 200);
                }
            }
        }, function() {
            var $this = $(this);
            clearTimeout(timeoutId);
            if ($this.hasClass('is-dropdown')) {
                if ($(window).width() > 767) {
                    isLeaving = true;
                }
            }
        });

        nav.find('[data-level-02]').hover(function() {
            if ($(window).width() > 767) {
                submenuHover = true;
            }
        }, function() {
            if ($(window).width() > 767) {
                submenuHover = false;
            }
        });

        nav.find('[data-level-03]').hover(function() {
            clearTimeout(timeoutId2);
            if ($(window).width() > 767) {
                subchildMenuHover = true;
            }
        }, function() {
            if ($(window).width() > 767) {
                subchildMenuHover = false;
                setTimeout(function() {
                    if(!submenuHover) {
                        clearTimeout(timeoutId2);
                    }
                }, 10);
                
            }
        });

        if (hambuger) {
            hambuger.addEventListener('click', function() {
                if (this.getAttribute('aria-expanded') === 'true') {
                    header.closeNav();
                } else {
                    $('[data-popup-content]').removeClass('on');
                    $('[data-popup-element]').removeClass('on');
                    header.openNav();
                }
            });
        }
    },
    stickyNav() {
        let lastScrollTop = 0;
        let st = 0;
        let triggerStart = 0;
        let triggerTransition = 400;

        function sticky() {
            st = window.scrollY;
            triggerStart = $('header').outerHeight(true) * 2;
            triggerTransition = $('header').outerHeight(true) * 4;

            if (st > triggerStart) {
                document.querySelector('body').classList.add('trigger-sticky');
            } else {
                document.querySelector('body').classList.remove('trigger-sticky');
            }

            if (st > triggerTransition) {
                document.querySelector('body').classList.add('trigger-transition');
            } else {
                document.querySelector('body').classList.remove('trigger-transition');
            }

            if (st > triggerTransition) {
                if (st > lastScrollTop) {
                    document.querySelector('body').classList.remove('scroll-up');
                    document.querySelector('body').classList.add('scroll-down');
                } else {
                    document.querySelector('body').classList.add('scroll-up');
                    document.querySelector('body').classList.remove('scroll-down');
                }

            } else {
                document.querySelector('body').classList.remove('scroll-up');
                document.querySelector('body').classList.remove('scroll-down');
            }
            lastScrollTop = st;
        }

        sticky();
        window.addEventListener('scroll', function() {
            sticky();
        });
    }
}

header.init();